import { TRootState } from 'Redux/Reducers';

export const getEventEmployeeIds = (state: TRootState) => state.event.assignedEmployeeIds;
